<template>
  <ul :id="burgermenu ? undefined : 'accountmenu'" :class="ulClasses" :aria-labelledby="burgermenu ? 'burgermenu-dropdown' : undefined">
    <!-- Logout -->
    <li role="presentation" :class="{ logout: !burgermenu }">
      <a v-if="simulating" href="#" role="button" @click.prevent="stopSimulating">
        <span class="glyphicon glyphicon-log-out" aria-hidden="true"></span>
        <span class="nav-label" :class="navLabelClasses">{{ $t('vue.components.accountmenu.users') }}</span>
      </a>
      <a v-else href="#" role="button" @click.prevent="logout">
        <span class="glyphicon glyphicon-log-out" aria-hidden="true"></span>
        <span class="nav-label" :class="navLabelClasses">{{ $t('vue.components.accountmenu.logout') }}</span>
      </a>
    </li>

    <!-- Users -->
    <li role="presentation" v-if="permissions.can_index_users" :class="{ active: isUsersRoute }">
      <router-link to="/users">
        <span class="glyphicon glyphicon-user" aria-hidden="true"></span>
        <span class="nav-label" :class="navLabelClasses">{{ $t('vue.components.accountmenu.users') }}</span>
      </router-link>
    </li>

    <!-- Products/Material -->
    <li role="presentation" v-if="permissions.can_index_products" :class="{ active: isProductsRoute }">
      <router-link to="/products">
        <span class="glyphicon glyphicon-equalizer" aria-hidden="true"></span>
        <span class="nav-label" :class="productNavClasses">{{ $t('vue.components.accountmenu.material') }}</span>
      </router-link>
    </li>

    <!-- Tasks -->
    <li role="presentation" v-if="permissions.can_index_tasks" :class="{ active: isTasksRoute }">
      <router-link to="/tasks">
        <span class="glyphicon glyphicon-check" aria-hidden="true"></span>
        <span class="nav-label" :class="taskNavClasses">{{ $t('vue.components.accountmenu.tasks') }}</span>
      </router-link>
    </li>

    <!-- Links -->
    <li role="presentation" v-if="permissions.can_view_links" :class="{ active: isLinksRoute }">
      <router-link to="/links">
        <span class="glyphicon glyphicon-bookmark" aria-hidden="true"></span>
        <span class="nav-label" :class="linksNavClasses">{{ $t('vue.components.accountmenu.links') }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { i18nFlash } from '../helpers/flash.js'

export default {
  name: 'account-menu',

  props: {
    user: { type: Object, required: true },
    permissions: { type: Object, required: true },
    simulating: { type: Boolean, default: false },
    sessionLinks: { type: Object, default: () => ({}) },
    burgermenu: { type: Boolean, default: false }
  },

  computed: {
    ulClasses() {
      if (this.burgermenu) {
        return ['dropdown-menu', 'dropdown-menu-right-align', 'nav', 'nav-stacked', 'dropdown-filters']
      }
      return ['nav-account', 'nav', 'nav-tabs', 'hidden-xs', 'hidden-sm', 'hidden-md']
    },

    navLabelClasses() {
      if (this.burgermenu) return []
      const classes = ['hidden-xs', 'hidden-sm', 'hidden-md']
      if (this.permissions.can_index_users) classes.push('hidden-lg')
      return classes
    },

    productNavClasses() {
      if (this.burgermenu) return []
      if (this.permissions.is_admin) return ['hidden-xs', 'hidden-sm', 'hidden-md', 'hidden-lg']
      return ['hidden-xs', 'hidden-sm']
    },

    taskNavClasses() {
      if (this.burgermenu) return []
      return ['hidden-xs', 'hidden-sm', 'hidden-md']
    },

    linksNavClasses() {
      if (this.burgermenu) return []
      return ['hidden-xs', 'hidden-sm']
    },

    isUsersRoute() {
      return ['users', 'user-new', 'user-edit', 'partners', 'partner-edit', 'partner-user-new'].includes(this.$route.name)
    },

    isProductsRoute() {
      return this.$route.path.startsWith('/products')
    },

    isTasksRoute() {
      return this.$route.name === 'tasks' ||
             this.$route.name === 'task-new' ||
             (this.$route.name === 'task-show' && !this.$route.params.projectId)
    },

    isLinksRoute() {
      return this.$route.name === 'links'
    }
  },

  methods: {
    async logout() {
      await this.$store.dispatch('app/logout')
      i18nFlash('vue.pages.login.signed_out', 'success')
      this.$router.push('/account/sign_in')
    },

    async stopSimulating() {
      await this.$store.dispatch('app/stopImpersonating')
      this.$router.push('/users')
    }
  }
}
</script>
